import {ConnectIframeInterface} from '../ConnectIframeInterface';

export class MockConnectIframeInterface implements ConnectIframeInterface {
  id: string = 'mock-iframe-id';
  src: string = 'mock-iframe-src';
  name: string = 'mock-iframe-name';
}
